import LinkOffIcon from '@mui/icons-material/LinkOff';
import { IconButton, Stack, Typography } from '@mui/material';
import { MouseEvent, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { EnhancedDialog } from '../../enhanced/dialog/EnhancedDialog';
import { TextCancelButton } from '../buttons/CancelButton';
import { TextConfirmButton } from '../buttons/ConfirmButton';

interface ConfirmationTableDialogProps {
  /** L'ID della riga da eliminare */
  id: number;
  /** Messaggio personalizzato */
  message?: string;
  handleUnlink?: (id: number) => void;
}

export default function ConfirmationUnlinkTableDialog({
  id,
  message,
  handleUnlink
}: ConfirmationTableDialogProps) {
  const { t } = useTranslation();

  const [openDialog, setOpenDialog] = useState(false);

  const handleOpenDialog = (e: MouseEvent<HTMLButtonElement>) => {
    e.stopPropagation();
    setOpenDialog(true);
  };

  const handleCloseDialog = (e?: MouseEvent<HTMLButtonElement>) => {
    if (e) e.stopPropagation();
    setOpenDialog(false);
  };

  const handleConfirmUnlink = (e: MouseEvent<HTMLButtonElement>) => {
    e.stopPropagation();
    if (handleUnlink) handleUnlink(id);
    setOpenDialog(false);
  };

  return (
    <>
      <IconButton onClick={handleOpenDialog}>
        <LinkOffIcon />
        <Typography>{t('actions.unlink')}</Typography>
      </IconButton>
      <EnhancedDialog
        open={openDialog}
        onClose={handleCloseDialog}
        onClick={(e) => e.stopPropagation()}
        title={t('actions.confirmation.unlink')}
        maxWidth="sm"
        costumFooter={
          <Stack direction="row" spacing={2} justifyContent="flex-end" sx={{ width: '100%' }}>
            <TextCancelButton handleCloseDialog={handleCloseDialog} />
            <TextConfirmButton handleConfirm={handleConfirmUnlink} label={t('actions.confirm')} />
          </Stack>
        }>
        {message ? message : 'Sei sicuro di voler scollegare questo elemento?'}
      </EnhancedDialog>
    </>
  );
}
